import React from "react";
import NewsSection from "../components/NewsSection";
import Candidates from "../components/Candidates";
import GrampanchayatVishayiHome from "../components/GrampanchayatVishayiHome";
import ThreeColumnsLayout from "../components/ThreeColumnsLayout";
import Gallery from "../components/Gallery";
import Notifications from "./Notifications";

const HomePage = () => {
  return (
    <div className="bg-gray-50">
      <NewsSection />
      <GrampanchayatVishayiHome />
      <Notifications/>
      <Candidates />
      <ThreeColumnsLayout />
      <Gallery />
    </div>
  );
};

export default HomePage;
